import styled, { css } from 'styled-components';
import { IconButton } from 'ui/button';
import { colors } from 'ui/theme';
import { WorkflowType } from '../../../enums';

const PUBLISHED_SELECT_STYLES = css`
  && {
    background: none;
    box-shadow: none;

    /**
     * Hack to fix css heritibility introduced in [this PR](https://github.com/Iterable/iterable-frontend/pull/8814/files#diff-bc7fb6c84fb35166e24a77b9031c54ad67f7d830df20901589985a0ca02cc0cd).
     *  Permanent fix to be introduced in [WF-5095](https://iterable.atlassian.net/browse/WF-5095)
     */
    svg:not(.shape) path {
      stroke: ${colors.textSecondary};
    }

    :focus {
      :before {
        border-color: ${colors.white};
      }
    }

    :hover {
      background: ${colors.purple10};
    }
  }
`;

export const MenuButton = styled(IconButton)`
  ${({ $workflowType }: { $workflowType: WorkflowType }) =>
    $workflowType === WorkflowType.PUBLISHED && PUBLISHED_SELECT_STYLES};
`;
